import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faEye, faPenToSquare, faPlus, faSort } from "@fortawesome/free-solid-svg-icons"
import type { QuickSearchActionType } from "../configuration/QuickSearchActions"

type QuickSearchActionTypeConfig = {
  icon: IconProp
  badgeClassName: string
  iconClassName: string
}

export const quickSearchActionTypeConfigs: Record<QuickSearchActionType, QuickSearchActionTypeConfig> = {
  create: {
    icon: faPlus,
    badgeClassName: "bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200",
    iconClassName: "bg-emerald-500 text-white",
  },
  edit: {
    icon: faPenToSquare,
    badgeClassName: "bg-blue-100 text-blue-700 ring-1 ring-blue-200",
    iconClassName: "bg-blue-500 text-white",
  },
  view: {
    icon: faEye,
    badgeClassName: "bg-orange-100 text-orange-700 ring-1 ring-orange-200",
    iconClassName: "bg-orange-500 text-white",
  },
  organize: {
    icon: faSort,
    badgeClassName: "bg-purple-100 text-purple-700 ring-1 ring-purple-200",
    iconClassName: "bg-purple-500 text-white",
  },
}

export const getQuickSearchActionTypeConfig = (type: string): QuickSearchActionTypeConfig =>
  type in quickSearchActionTypeConfigs
    ? quickSearchActionTypeConfigs[type as QuickSearchActionType]
    : quickSearchActionTypeConfigs.view
